import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

function ProjectFilesView() {
  const { id: projectId } = useParams();
  const [driveLink, setDriveLink] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProject = async () => {
      try {
        const projectRef = doc(db, 'projects', projectId);
        const projectSnap = await getDoc(projectRef);

        if (projectSnap.exists()) {
          const projectData = projectSnap.data();
          setDriveLink(projectData.driveLink || '');
        } else {
          console.error('Projeto não encontrado');
        }
      } catch (err) {
        console.error('Erro ao buscar projeto:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProject();
  }, [projectId]);

  if (loading) {
    return <p className="text-gray-600 text-center mt-20">Carregando arquivos...</p>;
  }

  if (!driveLink) {
    return <p className="text-red-500 text-center mt-20">Link do Google Drive não definido para este projeto.</p>;
  }

  const extractFolderId = (url) => {
    const match = url.match(/\/folders\/([a-zA-Z0-9_-]+)/);
    return match ? match[1] : null;
  };

  const folderId = extractFolderId(driveLink);

  if (!folderId) {
    return <p className="text-red-500 text-center mt-20">Link do Google Drive inválido.</p>;
  }

  return (
    <div className="p-4 space-y-4">
      <h2 className="text-2xl font-semibold">Arquivos do Projeto</h2>

      <p className="text-gray-700">
        ✅ Clique nos itens abaixo para <strong>navegar pelas pastas</strong> e <strong>baixar arquivos</strong>.
      </p>

      <a
        href={driveLink}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-block bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
      >
        Abrir no Google Drive
      </a>

      <iframe
        src={`https://drive.google.com/embeddedfolderview?id=${folderId}#list`}
        style={{ width: '100%', height: '600px', border: 'none' }}
        title="Arquivos do Projeto"
      ></iframe>
    </div>
  );
}

export default ProjectFilesView;
